import { List, Map, is } from 'immutable';
import {
  FETCHED_PUBLISHED_LESSONS,
  LESSON_PUBLISHED,
  PUBLISHED_LESSON_DELETED,
} from 'app/models/publishedLessonAdmin/constants';

const initialState = () => Map();

export const publishedLessonAdminReducer = (state = initialState(), action) => {
  switch (action.type) {
    case FETCHED_PUBLISHED_LESSONS: {
      const { lessonID, publishedIDs } = action.payload;
      // Preserve object identity over no-op updates
      const newIDs = List(publishedIDs);
      return state.update(lessonID, (existing) =>
        (is(existing, newIDs) ? existing : newIDs),
      );
    }
    case LESSON_PUBLISHED: {
      const { lessonID, publishedLessonID } = action.payload;
      return state.update(lessonID, (publishedIDs = List()) =>
        publishedIDs.push(publishedLessonID));
    }
    case PUBLISHED_LESSON_DELETED: {
      const { lessonID, publishedLessonID } = action.payload;
      return state.update(lessonID, (publishedIDs = List()) =>
        publishedIDs.filterNot((x) => x === publishedLessonID));
    }
    default:
      return state;
  }
};
